import { Controller, useFormContext } from 'react-hook-form';
import { Radio, RadioGroup, FormControlLabel, FormControl, TextField, Grid, Button, Box, Stack, CircularProgress } from '@mui/material';
import UploadFile from '../../../../../../../components/UploadFile';
import { usePermission } from '../../../../../../../components/PermissionGuard';

export default function StepAprovacao() {

    const criarTituloPermissao = usePermission('financeiro.contas-pagar-criacao-direta')
    const { control, watch, handleSubmit, getValues, getFieldState, formState: { errors } } = useFormContext();
    const selectedOption = watch('step_aprovacao.option');


    const handleBack = getValues('funcoesAux.onBack')
    const handleNext = getValues('funcoesAux.onNext')
    const onSubmit = getValues('funcoesAux.onSubmit')
    const isLoading = getValues('isLoadingIncluirTitulo')

    return (
        <Grid container spacing={2}>
            <Grid size={{xs: 12}}>
                <FormControl component="fieldset" sx={{ mb: 2 }}>
                    <Controller
                        name="step_aprovacao.option"
                        control={control}
                        render={({ field }) => (
                            <RadioGroup {...field}>
                                <FormControlLabel
                                    value="abrir_solicitacao"
                                    control={<Radio />}
                                    label="Abrir solicitação de criação de título a pagar"
                                />
                                <FormControlLabel
                                    value="criar_titulo"
                                    control={<Radio />}
                                    label="Prosseguir com a criação do título"
                                    disabled={!criarTituloPermissao}
                                />
                            </RadioGroup>
                        )}
                    />
                </FormControl>
                {selectedOption === 'abrir_solicitacao' && (
                    <Stack spacing={2}>
                        <Controller
                            name="step_aprovacao.justificativa"
                            control={control}
                            rules={{ required: "Campo obrigatório" }}
                            render={({ field }) => (
                                <TextField
                                    {...field}
                                    label="Justificativa"
                                    placeholder="Inclua sua justificativa aqui"
                                    multiline
                                    rows={4}
                                    variant="outlined"
                                    fullWidth
                                    required
                                    error={getFieldState('step_aprovacao.justificativa').invalid}
                                    helperText={getFieldState('step_aprovacao.justificativa').error?.message || ""}
                                />
                            )}
                        />

                        <Controller
                            name="step_aprovacao.anexos"
                            control={control}
                            render={({ field }) => (
                                <UploadFile
                                    {...field}
                                    multiple
                                    values={field.value}
                                    onChangeValues={field.onChange}
                                    type="formulario"
                                />
                            )}
                        />
                    </Stack>
                )}
            </Grid>

            <Grid size={{xs: 12}}>
                <Box display={'flex'} gap={2}>
                    <Button
                        variant="outlined"
                        onClick={handleBack}
                    >
                        Voltar
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleSubmit(
                            selectedOption === 'abrir_solicitacao' ? onSubmit : handleNext
                        )}
                        disabled={isLoading}
                    >
                        {isLoading && <CircularProgress size={20} sx={{ mr: 1 }} />}
                        {selectedOption === 'abrir_solicitacao' ? "Solicitar" : "Avançar"}
                    </Button>
                </Box>
            </Grid>
        </Grid>
    );
}   